import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const highlights = [
  { icon: 'ri-lightbulb-line', text: 'Daily focus & clarity tips' },
  { icon: 'ri-brain-line', text: 'Mind training exercises' },
  { icon: 'ri-flask-line', text: 'Honest nootropic reviews' },
  { icon: 'ri-group-line', text: 'A supportive private community' },
];

export default function Community() {
  return (
    <div className="min-h-screen bg-background-50 flex flex-col">
      <Navbar />
      <main className="flex-1 flex items-center justify-center px-4 sm:px-6 lg:px-8 pt-28 pb-20">
        <div className="w-full max-w-2xl text-center animate-fade-in-up">
          <div className="inline-flex items-center gap-2 bg-accent-500 text-foreground-950 text-sm font-label font-medium px-4 py-1.5 rounded-full mb-6">
            <i className="ri-rocket-line" />
            Launching Soon
          </div>

          <div className="w-20 h-20 mx-auto flex items-center justify-center rounded-2xl bg-background-100 border border-background-200/70 mb-6">
            <i className="ri-community-line text-4xl text-accent-600" />
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl font-bold text-foreground-950 mb-4 leading-tight">
            The ClearMind Club Community is Coming Soon
          </h1>

          <p className="text-foreground-600 font-body leading-relaxed max-w-xl mx-auto mb-8">
            We&apos;re putting the finishing touches on our private community space.
            It&apos;s almost ready — prepare for daily tips, mind training, nootropic breakdowns
            and a supportive group of clear-minded people.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-lg mx-auto mb-10">
            {highlights.map((item) => (
              <div
                key={item.text}
                className="flex items-center gap-3 bg-background-100 border border-background-200/70 rounded-lg px-4 py-3 text-left"
              >
                <i className={`${item.icon} text-accent-600 text-lg shrink-0`} />
                <span className="text-sm text-foreground-700 font-body">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 bg-primary-500 text-background-50 hover:bg-primary-600 h-12 rounded-lg text-base px-8"
            >
              <i className="ri-arrow-left-line" />
              Back to Home
            </Link>
            <Link
              to="/course"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap font-label font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-400 border border-background-300 bg-transparent hover:bg-background-100 h-12 rounded-lg text-base px-8 text-foreground-800"
            >
              Explore the Blueprint Course
              <i className="ri-arrow-right-line" />
            </Link>
          </div>

          <p className="text-xs text-foreground-500 mt-6 font-label">
            Educational content only &middot; Not a substitute for professional medical advice
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}